import styled from "styled-components";
import { colors, typography } from "@streeteasy/design-system";

const { H2, P } = typography;
const { ACCENT_PRIMARY_LIGHTEST } = colors;

export const List = styled.ul`
  display: flex;
`;

export const ItemContainer = styled.li`
  flex: 1;
  text-align: center;
`;

export const ListItem = styled(P)``;

export const Strong = styled(H2).attrs({
  as: "strong"
})`
  display: block;
  font-weight: normal;
  position: relative;
  z-index: 1;

  &::after {
    background-color: ${ACCENT_PRIMARY_LIGHTEST};
    border-radius: 15px;
    content: "";
    display: block;
    height: 30px;
    left: calc(50% - 5px);
    position: absolute;
    top: 9px;
    width: 30px;
    z-index: -1;
  }
`;

export const TooltipContainer = styled.span`
  display: inline-block;
`;

export const ListItemTooltip = styled.span`
  margin-left: 5px;
`;
